import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
* Статус платежа
* https://master.api-pay.sandbox.d2c.r-one.io/docs/v1#/Payment/7e1618c25d9948f7c8c91da0a7431187
* https://master.api-pay.sandbox.d2c.r-one.io/docs/v1#/UnauthPayment/6c8244b7adc3803265477a5b76ba7d0b
*/

export const getPaymentStatusAuth = (providerId: number, orderId: string): IRequest => {
    return {
        uri: '/payment/status',
        withAuth: true,
        withProvider: true,
        method: 'GET',
        queryParams: {
            billing_transaction_id: orderId,
            providerId,
        },
    };
};

export const getPaymentStatusUnAuth = (providerId: number, orderId: string): IRequest => {
    return {
        uri: '/unauth-payment/status',
        withAuth: true,
        method: 'GET',
        queryParams: {
            billing_transaction_id: orderId,
            providerId,
        },
    };
};
